import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { routeNaming, AppRedirect } from '../../../routes';
import { BasicInput } from '../../../common/basic-input';
import { SessionStore } from '../../../stores/SessionStore';
import { SecondaryButton } from '../../../common/secondary-button';
import { Validator } from '../../../helpers/Validator';
import { ScreenStore } from '../../../stores/ScreenStore';

import styles from './EditPassword.css';

const IPropTypes = {
  callbackSuccess: PropTypes.func.isRequired,
};

class EditPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actualPassword: null,
      newPassword: '',
      repeatPassword: '',

      newPasswordValid: false,
      passwordRepeatValid: false,
    };

    this._onSubmit = this._onSubmit.bind(this);
    this._updateActualPassword = this._updateActualPassword.bind(this);
    this._updateNewPassword = this._updateNewPassword.bind(this);
    this._updateRepeatPassword = this._updateRepeatPassword.bind(this);
  }

  _updateActualPassword(event) {
    const { target: { value } } = event;
    this.setState({ actualPassword: value });
  }

  _updateNewPassword(event) {
    const { target: { value } } = event;
    this.setState(prevState => ({
      newPassword: value,
      newPasswordValid: Validator.passwordIsValid(value),
      passwordRepeatValid: value === prevState.repeatPassword,
    }));
  }

  _updateRepeatPassword(event) {
    const { target: { value } } = event;
    this.setState(prevState => ({
      repeatPassword: value,
      passwordRepeatValid: prevState.newPassword === value,
    }));
  }

  _isValidData() {
    return this.state.newPasswordValid && this.state.passwordRepeatValid &&
      this.state.actualPassword && this.state.actualPassword !== '';
  }

  async _onSubmit(event) {
    event.preventDefault();
    if (!this._isValidData()) {
      return;
    }
    const data = {
      actualPassword: this.state.actualPassword,
      newPassword: this.state.newPassword,
    };
    await SessionStore.editPassword(data);
    if (!SessionStore.editPasswordError) {
      this.props.callbackSuccess();
    }
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }
    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
    const actualPasswordError = this.state.actualPassword === '' ? 'Este campo no puede ser vacío' : null;
    const newPasswordError = !this.state.newPasswordValid &&
      this.state.newPassword !== '' ? 'La contraseña debe tener al menos 6 caracteres' : null;
    const passwordRepeatError = !this.state.passwordRepeatValid &&
      this.state.repeatPassword !== '' ? 'La contraseñas deben ser iguales' : null;

    const labelStyle = mobileVersion ? styles.labelMobile : styles.label;
    return (
      <form
        className={styles.form}
        onSubmit={this._onSubmit}
      >
        <div className={styles.inputContainer}>
          <label className={labelStyle}>Contraseña actual</label>
          <BasicInput
            className={styles.input}
            label=""
            name="actualPassword"
            type="password"
            error={actualPasswordError}
            onChange={this._updateActualPassword}
          />
        </div>
        <div className={styles.inputContainer}>
          <label className={labelStyle}>Nueva contraseña</label>
          <BasicInput
            className={styles.input}
            label=""
            name="newPassword"
            type="password"
            error={newPasswordError}
            onChange={this._updateNewPassword}
          />
        </div>
        <div className={styles.inputContainer}>
          <label className={labelStyle}>Repetir nueva contraseña</label>
          <BasicInput
            className={styles.input}
            label=""
            name="repeatPassword"
            type="password"
            error={passwordRepeatError}
            onChange={this._updateRepeatPassword}
          />
        </div>
        <div className={styles.buttonContainer}>
          {
            SessionStore.editPasswordInternalError &&
            <p className={styles.error}>
              Ha ocurrido un error al cambiar la
              contraseña. Por favor, verifique los
              datos y vuelva a intentarlo.
            </p>
          }
          {
            SessionStore.editPasswordError &&
            <p className={styles.error}>
              La contraseña actual ingresada es incorrecta
            </p>
          }
          <SecondaryButton
            className={styles.button}
            type="submit"
            disabled={!this.state.actualPassword || this.state.actualPassword === '' ||
              !this.state.newPasswordValid || !this.state.passwordRepeatValid}
          >
            CAMBIAR
          </SecondaryButton>
        </div>
      </form>
    );
  }
}

EditPassword.propTypes = IPropTypes;

const ObservedEditPassword = observer(EditPassword);

export { ObservedEditPassword as EditPassword };



// WEBPACK FOOTER //
// ./src/pages/my-account/edit-password/EditPassword.jsx